import React, { useEffect, useMemo, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { headersItensArp, valoresExibidosItensARP } from './auxiliarArps';
import SubAbasArps from './subabasArps';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import CustomInputDate from '../../../../components/CustomInputs/CustomInputDate';
import CustomInputLink from '../../../../components/CustomInputs/CustomInputLink';
import CustomOffcanvas from '../../../../components/CustomOffcanvas';
import CustomRow from '../../../../components/CustomRow';
import CustomSelect from '../../../../components/CustomSelects/CustomSelect';
import FiscalContratoComponente from '../../../../components/FiscalContrato';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Checkbox from '../../../../components/Inputs/Checkbox';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import ParteEnvolvidaComponente from '../../../../components/ParteEnvolvida';
import ResponsavelAquisicaoComponente from '../../../../components/ResponsavelAquisicao';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import TermoAditivoComponente from '../../../../components/TermoAditivo';
import TramitacaoComponente from '../../../../components/Tramitacao';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { IProdutoDafRegistro } from '../../../../modules/types/ProdutoDaf';
import { LogData } from '../../../../modules/types/types';
import { useDenominacoesGenericasCache } from '../../../../services/cache/useDenominacoesGenericasCache';
import { useFornecedoresCache } from '../../../../services/cache/useFornecedoresCache';
import { useKitDeProdutosCache } from '../../../../services/cache/useKitsProdutosCache';
import { useProdutosDafCache } from '../../../../services/cache/useProdutosDafCache';
import { getItensPorArp } from '../../../../services/contratos/arpsItensService';
import { getArp } from '../../../../services/contratos/arpsService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { getProdutosByProaqId } from '../../../../services/processosAquisitivos/proaqItemService';
import { getProdutosDoKit } from '../../../../services/produtosDAF/kitProdutoService';
import theme from '../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatDate,
  formatDateSimp,
  formatoMoney,
  formatValorDinheiro,
} from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';

interface FormItemArp {
  [key: string]: string | number | boolean | null;
  id: string;
  usuarioId: any;
  arpId: number;
  produtoDafId: number;
  tipoCotaArp: number;
  empateFicto: number;
  embalagemFator: string;
  embalagemTotal: string;
  qtdAdministrativa: string;
  qtdEstrategico: string;
  qtdJudicial: string;
  qtdOutro: string;
  qtdTotal: string;
  valorUnitHomologado: string;
  valorReequilibrioBin: boolean;
  valorUnitReequilibrio: string | null;
  valorTotal: string;
  medContratos: string;
  medQtdContratada: string;
  medValorContratado: string;
  medQtdSaldo: string;
  medValorSaldo: string;
  medPercentSaldo: string;
  observacoes: string;
}

export interface IProdutoProaqRegistro {
  produtoId: number;
  nomeProduto: string;
}

export default function ArpsFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';

  const navigate = useNavigate();
  const location = useLocation();
  const locationData = location.state;
  const params = useParams();
  const fichaID = String(params.id);
  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);
  //Dados do componente
  let logs = {};
  let subAbas = [];

  //Dados
  const { getSelectDominioPai } = useSelect();
  const statusVigenciaOptions = getSelectDominioPai(68);
  const componenteAFoptions = getSelectDominioPai(1);
  const leiLicitacaoOptions = getSelectDominioPai(65);
  const tipoCotaArpOptions = getSelectDominioPai(72);

  const valoresBin = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Sim' },
    { value: 2, label: 'Não' },
  ];

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getArp(id);
      setLogData(registroData);

      let dataFimVigencia: Date | null = null;
      let prazoVigencia = '';

      if (registroData.dataPublicacao) {
        dataFimVigencia = new Date(registroData.dataPublicacao);
        dataFimVigencia.setDate(dataFimVigencia.getDate() + 365);

        const hoje = new Date();
        const dias = Math.ceil(
          (dataFimVigencia.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
        );
        prazoVigencia = dias.toString();
      }

      const dataPublicacao = registroData.dataPublicacao
        ? new Date(registroData.dataPublicacao).toISOString().split('T')[0]
        : '';

      const dataVigencia = registroData.dataVigencia
        ? new Date(registroData.dataVigencia).toISOString().split('T')[0]
        : '';

      setFormArp({
        usuarioId: userID,
        denominacaoGenericaId: registroData.denominacaoGenerica
          ? registroData.denominacaoGenerica.id
          : 0,
        kitProdutosDAFId: registroData.kitProdutosDAF
          ? registroData.kitProdutosDAF.id
          : 0,
        componenteAf: registroData.componenteAf,
        fornecedorId: registroData.fornecedor.id,
        proaqId: registroData.proaq.id,
        statusArp: registroData.statusArp,
        leiLicitacao: registroData.leiLicitacao,
        numeroSeiArp: registroData.numeroSeiArp,
        numeroArp: registroData.numeroArp,
        dataPublicacao: dataPublicacao,
        dataVigencia: dataVigencia,
        prazoVigencia: prazoVigencia,
        observacoes: registroData.observacoes,
      });
      triggerRefresh();
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });
  const [formArp, setFormArp] = useState({
    usuarioId: userID,
    denominacaoGenericaId: locationData?.formNewArp?.denominacaoId || 0,
    kitProdutosDAFId: locationData?.formNewArp?.kitId || 0,
    componenteAf: locationData ? locationData.formNewArp.componenteAf : 0,
    fornecedorId: locationData ? locationData.formNewArp.fornecedorId : 0,
    proaqId: locationData ? locationData.formNewArp.proaqId : 0,
    statusArp: 0,
    leiLicitacao: 0,
    numeroSeiArp: locationData ? locationData.formNewArp.proaqLabel : 0,
    numeroArp: '',
    dataPublicacao: '',
    dataVigencia: '',
    prazoVigencia: '',
    observacoes: '',
  });

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID);
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasArps(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/proaq/arps/dadosgerais`,
      },
    ];
  }

  useEffect(() => {
    if (formArp.denominacaoGenericaId || formArp.kitProdutosDAFId) {
      fetchDataItensArp(fichaID);
    }
  }, [formArp]);

  const { data: kitsProdutosData } = useKitDeProdutosCache();
  const kitProdutoOptions = [
    { value: 0, label: 'Não informado' },
    ...kitsProdutosData.map((item) => ({
      value: item.id,
      label: item.nomeKit,
    })),
  ];

  const { data: denominacoesGenericasData } = useDenominacoesGenericasCache();
  const denominacoesGenericasOptions = [
    { value: 0, label: 'Não informado' },
    ...denominacoesGenericasData.map((item) => ({
      value: item.id,
      label: item.denominacaoGenerica,
    })),
  ];

  const [produtosProaqData, setProdutosProaqData] = useState<
    IProdutoProaqRegistro[]
  >([]);

  useEffect(() => {
    if (!formArp.proaqId) {
      setProdutosProaqData([]);
      return;
    }

    getProdutosByProaqId(formArp.proaqId.toString()).then((result) => {
      setProdutosProaqData(result ?? []);
    });
  }, [formArp.proaqId]);

  const produtosProaqOptions = useMemo(() => {
    return [
      { value: 0, label: 'Não informado' },
      ...produtosProaqData.map((item) => ({
        value: Number(item.produtoId),
        label: item.nomeProduto,
      })),
    ];
  }, [produtosProaqData]);

  const { data: fornecedoresData } = useFornecedoresCache();
  const fornecedoresOptions = [
    { value: 0, label: 'Não informado' },
    ...fornecedoresData.map((item) => ({
      value: item.id,
      label: item.nomeFantasia,
    })),
  ];

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    if (name === 'dataPublicacao') {
      const novaDataVigencia = new Date(value);
      novaDataVigencia.setDate(novaDataVigencia.getDate() + 365);

      // Calcula o prazo como hoje - dataVigencia
      const hoje = new Date();
      const diferencaEmDias = Math.ceil(
        (novaDataVigencia.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
      );

      setFormArp((prevState) => ({
        ...prevState,
        dataPublicacao: value,
        dataVigencia: novaDataVigencia.toISOString().split('T')[0], // Formato YYYY-MM-DD
        prazoVigencia: diferencaEmDias > 0 ? diferencaEmDias.toString() : '', // Define 0 se a diferença for negativa
      }));
    } else {
      setFormArp((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (name === 'dataVigencia') {
      const dataVigencia = new Date(value);

      // Calcula o prazo como hoje - dataVigencia
      const hoje = new Date();
      const diferencaEmDias = Math.ceil(
        (dataVigencia.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
      );

      setFormArp((prevState) => ({
        ...prevState,
        dataVigencia: dataVigencia.toISOString().split('T')[0], // Formato YYYY-MM-DD
        prazoVigencia: diferencaEmDias > 0 ? diferencaEmDias.toString() : '', // Define 0 se a diferença for negativa
      }));
    }
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusArp) {
      errors.push('<b>Status da ARP</b> é obrigatório.');
    }

    if (Number(form.componenteAf) === 0 || !form.componenteAf) {
      errors.push('<b>Componente AF</b> é obrigatório.');
    }

    if (!form.leiLicitacao) {
      errors.push('<b>Lei de Licitação</b> é obrigatório.');
    }

    if (!form.numeroArp) {
      errors.push('<b>Nº da ARP</b> é obrigatório.');
    }

    if (Number(form.statusArp) > 69 && form.dataPublicacao == '') {
      errors.push('<b>Data de Início</b> da vigência é obrigatório.');
    }

    if (Number(form.statusArp) > 69 && form.dataVigencia == '') {
      errors.push('<b>Data de Término</b> da vigência é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar ACTs.',
        showConfirmButton: true,
      });
      return;
    }
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formArp);
      if (!isFormValid) return;

      const formToSend = {
        ...formArp,
        statusArp: Number(formArp.statusArp),
        leiLicitacao: Number(formArp.leiLicitacao),
        componenteAf: Number(formArp.componenteAf),
        dataPublicacao: formArp.dataPublicacao ? formArp.dataPublicacao : null,
        dataVigencia: formArp.dataVigencia ? formArp.dataVigencia : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/arp/`, formToSend);

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/proaq/arps/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formArp);
      if (!isFormValid) return;

      const formToSend = {
        ...formArp,
        statusArp: Number(formArp.statusArp),
        leiLicitacao: Number(formArp.leiLicitacao),
        dataPublicacao: formArp.dataPublicacao ? formArp.dataPublicacao : null,
        dataVigencia: formArp.dataVigencia ? formArp.dataVigencia : null,
      };

      const response = await httpClient.patch(
        `/api/arp/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/arp/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/proaq/arps');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const [isDataPublicacaoReadOnly, setIsDataPublicacaoReadOnly] =
    useState(false);
  useEffect(() => {
    if (formArp.statusArp != 1) {
      setIsDataPublicacaoReadOnly(false);
    } else {
      setIsDataPublicacaoReadOnly(true);
      setFormArp((prev) => ({
        ...prev,
        dataPublicacao: '',
        dataVigencia: '',
        prazoVigencia: '',
      }));
    }
  }, [formArp.statusArp]);

  //////////////////////////////////
  //////////////////////////////////
  //////////////////////////////////
  //////////////////////////////////
  //////////////////////////////////
  ////////////////////////////////// Item da ARP
  const [itemArpId, setItemArpId] = useState<string>('');
  const [showModalItemArp, setShowModalItemArp] = useState<boolean>(false);
  const [logItemArpData, setLogItemArpData] = useState<LogData>();

  const [formItemArp, setFormItemArp] = useState<FormItemArp>({
    id: '',
    usuarioId: userID,

    //Chaves estrangeiras
    arpId: 0,
    produtoDafId: 0,
    tipoCotaArp: 0,
    empateFicto: 0,

    //Embalagem
    embalagemFator: '',
    embalagemTotal: '',

    //Quantidades
    qtdAdministrativa: '0',
    qtdEstrategico: '0',
    qtdJudicial: '0',
    qtdOutro: '0',
    qtdTotal: '0',

    //Valores
    valorUnitHomologado: '',
    valorReequilibrioBin: false,
    valorUnitReequilibrio: null as string | null,
    valorTotal: '',

    //Métricas
    medContratos: '',
    medQtdContratada: '',
    medValorContratado: '',
    medQtdSaldo: '',
    medValorSaldo: '',
    medPercentSaldo: '',

    //Observações
    observacoes: '',
  });

  const handleRowClickItemArp = (id: string) => {
    setItemArpId(id);
    handleShowModalItemArp();
    const filteredItem = itensArpData.find((item) => item.id == id);
    if (filteredItem) {
      setDadosItemArp(filteredItem);
    }
  };

  const setDadosItemArp = (item: any) => {
    const valorUnitHomologado = item.valorUnitHomologado
      ? parseFloat(
          item.valorUnitHomologado.replace('.', '').replace(',', '.'),
        ) / 10
      : 0;

    const valorReequilibrioBin = item.valorReequilibrioBin;
    let valorUnitReequilibrio = 0;
    if (valorReequilibrioBin === 'S') {
      valorUnitReequilibrio =
        parseFloat(
          item.valorUnitReequilibrio.replace('.', '').replace(',', '.'),
        ) / 10;
    }

    const qtdEmbalagens = Math.round(item.qtdTotal / item.embalagemFator);
    setFormItemArp({
      id: item.id,
      usuarioId: userID,

      //Chaves estrangeiras
      arpId: item.arp.id,
      produtoDafId: item.produtoDAF.id,
      tipoCotaArp: item.tipoCotaArp,
      empateFicto: item.empateFicto === 'S' ? 1 : 2,

      //Embalagem
      embalagemFator: formatarNumero(item.embalagemFator),
      embalagemTotal: formatarNumero(qtdEmbalagens),

      //Quantidades
      qtdAdministrativa: formatarNumero(item.qtdAdministrativa),
      qtdEstrategico: formatarNumero(item.qtdEstrategico),
      qtdJudicial: formatarNumero(item.qtdJudicial),
      qtdOutro: formatarNumero(item.qtdOutro),
      qtdTotal: formatarNumero(item.qtdTotal),

      //Valores
      valorUnitHomologado: valorUnitHomologado
        ? formatoMoney(valorUnitHomologado.toString())
        : '',
      valorReequilibrioBin: item.valorReequilibrioBin === 'S' ? true : false,
      valorUnitReequilibrio: item.valorUnitReequilibrio
        ? formatoMoney(valorUnitReequilibrio.toString())
        : '',
      valorTotal: formatoMoney(item.valorTotal.toFixed(2)),

      //Métricas
      medContratos: '',
      medQtdContratada: '',
      medValorContratado: '',
      medQtdSaldo: '',
      medValorSaldo: '',
      medPercentSaldo: '',

      //Observações
      observacoes: item.observacoes,
    });
    setLogItemArpData({
      id: item.id,
      usuarioRegistro: item.usuarioRegistro.nomeCompleto || '',
      usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto || '',
      dataRegistro: item.dataRegistro,
      dataAtualizacao: item.dataUltimaAtualizacao,
      nEdicoes: item.nEdicoes,
    });
  };

  const handleShowModalItemArp = () => {
    setShowModalItemArp((prev) => !prev);
    handleClearFormItemArp();
  };

  const handleClearFormItemArp = () => {
    setFormItemArp({
      id: '',
      usuarioId: userID,

      //Chaves estrangeiras
      arpId: 0,
      produtoDafId: 0,
      tipoCotaArp: 0,
      empateFicto: 0,

      //Embalagem
      embalagemFator: '',
      embalagemTotal: '',

      //Quantidades
      qtdAdministrativa: '',
      qtdEstrategico: '',
      qtdJudicial: '',
      qtdOutro: '',
      qtdTotal: '',

      //Valores
      valorUnitHomologado: '',
      valorReequilibrioBin: false,
      valorUnitReequilibrio: null,
      valorTotal: '',

      //Métricas
      medContratos: '',
      medQtdContratada: '',
      medValorContratado: '',
      medQtdSaldo: '',
      medValorSaldo: '',
      medPercentSaldo: '',

      //Observações
      observacoes: '',
    });
  };

  const handleChangeItemArp = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, type, value, checked } = event.target as HTMLInputElement;

    setFormItemArp((prev) => {
      const newValue =
        type === 'checkbox'
          ? checked
          : name.startsWith('valor')
            ? formatoMoney(value)
            : name === 'embalagemFator' || name.startsWith('qtd')
              ? formatarNumero(value)
              : value;

      const camposQtd = [
        'qtdAdministrativa',
        'qtdEstrategico',
        'qtdJudicial',
        'qtdOutro',
      ];

      const novasQuantidades = {
        ...prev,
        [name]: newValue,
      };

      // Recalcular qtdTotal
      let qtdTotal = prev.qtdTotal;
      if (camposQtd.includes(name)) {
        const soma = camposQtd
          .map((campo) =>
            Number(String(novasQuantidades[campo] ?? '0').replace(/\./g, '')),
          )
          .reduce((acc, val) => acc + val, 0);

        qtdTotal = formatarNumero(soma.toString());
        novasQuantidades.qtdTotal = qtdTotal; // atualiza diretamente no objeto usado abaixo
      }

      // Recalcular valores
      const qtdTotalNumber = Number(
        (novasQuantidades.qtdTotal || '0').replace(/\./g, ''),
      );
      const valorUnitHomologadoNumber = Number(
        (novasQuantidades.valorUnitHomologado || '0')
          .replace(/\./g, '')
          .replace(',', '.'),
      );
      const valorUnitReequilibrioNumber = Number(
        (novasQuantidades.valorUnitReequilibrio || '0')
          .replace(/\./g, '')
          .replace(',', '.'),
      );

      const valorTotalCalculado = novasQuantidades.valorReequilibrioBin
        ? qtdTotalNumber * valorUnitReequilibrioNumber
        : qtdTotalNumber * valorUnitHomologadoNumber;

      // Recalcular embalagemTotal
      const embalagemFatorNumber = Number(
        (novasQuantidades.embalagemFator || '0').replace(/\./g, ''),
      );

      let embalagemTotal = '0';
      if (embalagemFatorNumber > 0) {
        const total = qtdTotalNumber / embalagemFatorNumber;
        embalagemTotal = formatarNumero(Math.floor(total).toString()); // ou usar `.toFixed(0)` se quiser string decimal
      }

      return {
        ...novasQuantidades,
        qtdTotal,
        valorTotal: formatoMoney(valorTotalCalculado.toFixed(2)),
        embalagemTotal,
      };
    });
  };

  const [itensArpData, setItensArpData] = useState<any[]>([]);
  const fetchDataItensArp = async (id: string) => {
    try {
      const itensData = await getItensPorArp(id);
      console.log('Fetched Itens Data:', itensData);
      if (itensData.length > 0) {
        setItensArpData(itensData);
      }
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //FUNÇÕES HANDLE CRUD
  const handleCreateItemArp = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateFormItemArp(formItemArp);
      if (!isFormValid) return false;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormItemArpBeforeSubmit(formItemArp);

      console.log('Adjusted Form to Submit:', adjustedForm);

      await httpClient.post(`/api/arp-item/`, adjustedForm);

      swalSave();
      fetchDataItensArp(fichaID);
      // setTimeout(() => handleShowModalTramitacao(), 2000);
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdateItemArp = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateFormItemArp(formItemArp);
      if (!isFormValid) return false;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormItemArpBeforeSubmit(formItemArp);

      const idItemArp = formItemArp.id;

      // const token = 'JWT_SECRET';

      // Salvar a atualização
      await httpClient.patch(`/api/arp-item/${idItemArp}`, adjustedForm);
      swalAtualizacao('Sucesso', 'Registro atualizado com sucesso!');

      // Busca os dados atualizados diretamente após a atualização
      await fetchDataItensArp(fichaID);
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleDeleteItemArp = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/arp-item/${itemArpId}`);
        swalDeleteConfirm();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  const validateFormItemArp = (formItemArp: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (formItemArp.tipoCota === 0) {
      errors.push('<b>Tipo de Cota</b> é obrigatório.');
    }

    if (formItemArp.empateFicto === 0) {
      errors.push('<b>Empate Ficto</b> é obrigatório.');
    }

    if (formItemArp.produtoDafId === 0) {
      errors.push('<b>Produto Farmacêutico</b> é obrigatório.');
    }

    if (formItemArp.qtdAdministrativa === '') {
      errors.push('<b>Qtd ADMINISTRATIVA</b> é obrigatório.');
    }

    if (formItemArp.qtdEstrategico === '') {
      errors.push('<b>Qtd ESTRATEGICO</b> é obrigatório.');
    }

    if (formItemArp.qtdJudicial === '') {
      errors.push('<b>Qtd JUDICIAL</b> é obrigatório.');
    }

    if (formItemArp.qtdOutro === '') {
      errors.push('<b>Qtd OUTRO</b> é obrigatório.');
    }

    if (formItemArp.valorUnitHomologado === '') {
      errors.push('<b>Valor Unitário Homologado</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const adjustFormItemArpBeforeSubmit = (formItemArp: any) => {
    let valorReequilibrio = 0;
    if (formItemArp.valorReequilibrioBin) {
      valorReequilibrio = Number(
        formItemArp.valorUnitReequilibrio.replace(/\./g, '').replace(',', '.'),
      );
    }

    const adjustedForm = {
      ...formItemArp,
      arpId: Number(fichaID),
      produtoDafId: Number(formItemArp.produtoDafId),
      tipoCota: Number(formItemArp.tipoCotaArp),
      empateFicto: formItemArp.empateFicto === '1' ? 'S' : 'N',

      //Quantidades
      embalagemFator: Number(formItemArp.embalagemFator.replace(/\./g, '')),
      qtdAdministrativa: Number(
        formItemArp.qtdAdministrativa.replace(/\./g, ''),
      ),
      qtdEstrategico: Number(formItemArp.qtdEstrategico.replace(/\./g, '')),
      qtdJudicial: Number(formItemArp.qtdJudicial.replace(/\./g, '')),
      qtdOutro: Number(formItemArp.qtdOutro.replace(/\./g, '')),

      //Valores
      valorUnitHomologado: Number(
        formItemArp.valorUnitHomologado.replace(/\./g, '').replace(',', '.'),
      ),
      valorReequilibrioBin: formItemArp.valorReequilibrioBin ? 'S' : 'N',
      valorUnitReequilibrio: formItemArp.valorReequilibrioBin
        ? valorReequilibrio
        : null,

      //Observações
      observacoes:
        formItemArp.observacoes === ''
          ? 'Sem observações específicas.'
          : formItemArp.observacoes,
    };

    // Remover campos não desejados
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { embalagemTotal, qtdTotal, valorTotal, ...cleanForm } = adjustedForm;

    return cleanForm;
  };

  //TABLE E OFFCANVAS
  const tableDataItensArp = itensArpData.map((item) => {
    // Converte valorUnitHomologado para número
    const valorUnitHomologado = item.valorUnitHomologado
      ? parseFloat(
          item.valorUnitHomologado.replace(/\./g, '').replace(',', '.'),
        ) / 10
      : 0;

    // Converte valorUnitReequilibrio para número (adicionada verificação para null)
    const valorUnitReequilibrio =
      item.valorReequilibrioBin && item.valorUnitReequilibrio
        ? parseFloat(
            item.valorUnitReequilibrio.replace(/\./g, '').replace(',', '.'),
          ) / 10
        : 0;

    return {
      id: item.id,
      tipoCotaArp: tipoCotaArpOptions.find(
        (option) => option.value === item.tipoCotaArp,
      )?.label,
      itemProduto: item.produtoDAF.produtoFarmaceutico,
      itemQtdRegistrada: (
        <span
          style={{
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'right',
            fontWeight: 'bold',
          }}
        >
          {formatarNumero(String(item.qtdTotal)) || 0}
        </span>
      ),
      itemValorHomologado: (
        <span
          style={{
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'right',
            fontWeight: 'bold',
          }}
        >
          {item.valorUnitHomologado
            ? formatoMoney(valorUnitHomologado.toString())
            : 0}
        </span>
      ),
      itemValorReequilibrio: (
        <span
          style={{
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'right',
            fontWeight: 'bold',
          }}
        >
          {item.valorReequilibrioBin === 'S' && item.valorUnitReequilibrio
            ? formatoMoney(valorUnitReequilibrio.toString())
            : '-'}
        </span>
      ),
      itemValorTotal: (
        <span
          style={{
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'right',
            fontWeight: 'bold',
          }}
        >
          {formatoMoney(item.valorTotal.toFixed(2))}
        </span>
      ),
    };
  });

  //USE EFFECT
  const [
    isValorUnitarioHomologadoReadOnly,
    setIsValorUnitarioHomologadoReadOnly,
  ] = useState(false);
  useEffect(() => {
    if (formItemArp.valorReequilibrioBin === false) {
      setIsValorUnitarioHomologadoReadOnly(true);
      setFormItemArp((prev) => ({
        ...prev,
        valorUnitReequilibrio: null,
      }));
    } else {
      setIsValorUnitarioHomologadoReadOnly(false);
    }
  }, [formItemArp.valorReequilibrioBin]);

  useEffect(() => {
    const { dataPublicacao, dataVigencia } = formArp;

    if (dataPublicacao && dataVigencia) {
      const dtPub = new Date(dataPublicacao);
      const dtVig = new Date(dataVigencia);

      if (dtVig < dtPub) {
        setFormArp((prev) => ({
          ...prev,
          dataVigencia: '',
        }));
        swalAttention(
          `A data de <b>vigência</b> ${formatDateSimp(dataVigencia)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>início</b> ${formatDateSimp(dataPublicacao)}.`,
        );
      }
    }
  }, [formArp.dataPublicacao, formArp.dataVigencia]);

  const [isDataRequired, setIsDataRequired] = useState(false);
  useEffect(() => {
    // alert(Number(formArp.statusArp));
    if (Number(formArp.statusArp) > 69) {
      setIsDataRequired(true);
    } else {
      setIsDataRequired(false);
      setFormArp((prev) => ({
        ...prev,
        dataPublicacao: '',
        dataVigencia: '',
        prazoVigencia: '',
      }));
    }
  }, [formArp.statusArp]);

  const getMaxDateVigencia = (
    dataPublicacao?: string,
    leiLicitacao?: number,
  ): Date | undefined => {
    if (!dataPublicacao) return undefined;

    const baseDate = new Date(dataPublicacao);

    if (Number(leiLicitacao) === 66) {
      baseDate.setFullYear(baseDate.getFullYear() + 1);
      return baseDate;
    }

    if (Number(leiLicitacao) === 67) {
      baseDate.setFullYear(baseDate.getFullYear() + 2);
      return baseDate;
    }

    return undefined;
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/arps"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {fichaID !== 'undefined' && (
            <Log
              {...logs}
              entity="TB_ARP"
              id={Number(fichaID)}
              refreshTriggerLog={refreshTriggerLog}
            />
          )}

          {/* Dados da ARP */}
          <BoxConteudo boxTitulo="Dados da ARP">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusArp"
                  options={statusVigenciaOptions}
                  label="Status"
                  value={formArp.statusArp}
                  onChange={handleChange}
                  // style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="componenteAf"
                  options={componenteAFoptions}
                  label="Componente AF"
                  value={formArp.componenteAf}
                  onChange={handleChange}
                  disabled
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="leiLicitacao"
                  options={leiLicitacaoOptions}
                  label="Lei de Licitação"
                  value={formArp.leiLicitacao}
                  onChange={handleChange}
                  required
                />
              </CustomCol>

              <CustomCol width="230px">
                <Input
                  name="numeroSeiArp"
                  label="Nº Processo SEI"
                  value={formArp.numeroSeiArp}
                  id="numeroSeiArp"
                  onChange={handleChange}
                  mascara="99999.999999/9999-99"
                  readonly
                  onClick={() => {
                    if (formArp.proaqId) {
                      const url = `#/daf/proaq/processos/${formArp.proaqId}/dadosgerais`;
                      window.open(url, '_blank');
                    }
                  }}
                  style={{
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="numeroArp"
                  label="Nº ARP"
                  value={formArp.numeroArp}
                  id="numeroArp"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol
                width="180px"
                helpText="Data inicial da vigência da ARP"
              >
                <CustomInputDate
                  name="dataPublicacao"
                  title="Início da Vigência"
                  value={formArp.dataPublicacao}
                  onChange={handleChange}
                  readOnly={isDataPublicacaoReadOnly}
                  required={isDataRequired}
                />
              </CustomCol>

              <CustomCol width="180px" helpText="Data final da vigência da ARP">
                <CustomInputDate
                  name="dataVigencia"
                  title="Término da Vigência"
                  value={formArp.dataVigencia}
                  onChange={handleChange}
                  readOnly={isDataPublicacaoReadOnly || !formArp.dataPublicacao}
                  required={isDataRequired && !!formArp.dataPublicacao}
                  minDate={
                    formArp.dataPublicacao
                      ? new Date(formArp.dataPublicacao)
                      : undefined
                  }
                  maxDate={getMaxDateVigencia(
                    formArp.dataPublicacao,
                    formArp.leiLicitacao,
                  )}
                />
              </CustomCol>

              <CustomCol helpText="Prazo da vigência em dias">
                <Input
                  name="prazoVigencia"
                  label="Prazo"
                  value={formArp.prazoVigencia}
                  id="prazoArp"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            {/* Denominação Genérica / Kit de Produto */}
            {formArp.denominacaoGenericaId &&
            formArp.denominacaoGenericaId !== 0 ? (
              <CustomRow>
                <CustomCol>
                  <CustomInputLink
                    title={
                      formArp.denominacaoGenericaId
                        ? 'Denominação Genérica'
                        : 'Kit de Produtos'
                    }
                    name={
                      formArp.denominacaoGenericaId
                        ? 'denominacaoGenericaId'
                        : 'kitProdutosDAFId'
                    }
                    label={
                      formArp.denominacaoGenericaId
                        ? denominacoesGenericasOptions.find(
                            (option) =>
                              option.value === formArp.denominacaoGenericaId,
                          )?.label || ''
                        : kitProdutoOptions.find(
                            (option) =>
                              option.value === formArp.kitProdutosDAFId,
                          )?.label || ''
                    }
                    readOnly
                    validateUrl={false}
                    value={
                      formArp.denominacaoGenericaId
                        ? `#/daf/produtosdaf/denominacoes/${formArp.denominacaoGenericaId}/dadosgerais`
                        : `#/daf/produtosdaf/kits/${formArp.kitProdutosDAFId}/dadosgerais`
                    }
                    copyToClipboard={false}
                  />
                </CustomCol>
              </CustomRow>
            ) : null}
            {/* Fornecedor */}
            <CustomRow>
              <CustomCol>
                <CustomInputLink
                  title="Fornecedor"
                  name="fornecedorId"
                  label={
                    formArp.fornecedorId
                      ? fornecedoresOptions.find(
                          (option) => option.value === formArp.fornecedorId,
                        )?.label || ''
                      : ''
                  }
                  readOnly
                  validateUrl={false}
                  value={
                    formArp.fornecedorId
                      ? `#/daf/fornecedores/fornecedores/${formArp.fornecedorId}/dadosgerais`
                      : ''
                  }
                  copyToClipboard={false}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {fichaID !== 'undefined' && (
            <>
              {/* Item da ARP */}
              <BoxConteudo boxTitulo="Item da ARP">
                <CustomRow>
                  <CustomCol width="100%">
                    <Tabela
                      headers={headersItensArp}
                      dataTable={tableDataItensArp}
                      onRowClick={handleRowClickItemArp}
                      botaoAbrirOffCanvas={false}
                      noOffCanvasTable
                      showPagination={false}
                    />
                  </CustomCol>
                </CustomRow>
                <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
                  <CustomButton
                    label="Novo Item da ARP"
                    bgColor={theme.colors.botaoAcao.azul}
                    textColor={theme.colors.white}
                    onClick={() => {
                      handleShowModalItemArp();
                    }}
                    disabled={fichaID == 'undefined' ? true : false}
                  />
                </CustomCol>
              </BoxConteudo>

              {/* Modal Item da ARP /*/}
              <CustomOffcanvas
                title="Item da ARP"
                show={showModalItemArp}
                onClose={handleShowModalItemArp}
                width="70vw"
              >
                <WorkspaceFicha>
                  <Log
                    {...logItemArpData}
                    entity="TB_ARP_ITEM"
                    id={Number(logItemArpData?.id)}
                  />
                  <BoxConteudo boxTitulo="Dados do Item da ARP">
                    <CustomRow style={{ marginTop: '-15px' }}>
                      <CustomCol width="200px">
                        <SelectInput
                          name="tipoCotaArp"
                          options={tipoCotaArpOptions}
                          label="Tipo de Cota"
                          value={Number(formItemArp.tipoCotaArp ?? 0)}
                          onChange={handleChangeItemArp}
                          required
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <SelectInput
                          name="empateFicto"
                          options={valoresBin}
                          label="Empate Ficto"
                          value={formItemArp.empateFicto}
                          onChange={handleChangeItemArp}
                          required
                        />
                      </CustomCol>
                      <CustomCol>
                        <CustomSelect
                          title="Produto Farmacêutico"
                          name="produtoDafId"
                          options={produtosProaqOptions}
                          value={formItemArp.produtoDafId}
                          onChange={handleChangeItemArp}
                          required
                        />
                      </CustomCol>
                    </CustomRow>

                    {/* Quantidade e Valores da ARP */}
                    <CustomRow>
                      <CustomCol width="150px">
                        <Input
                          name="embalagemFator"
                          label="Fator Embalagem"
                          value={formItemArp.embalagemFator}
                          id="embalagemFator"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          required
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="qtdAdministrativa"
                          label="Qtd Administrativa"
                          value={formItemArp.qtdAdministrativa}
                          id="qtdAdministrativa"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          required
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="qtdEstrategico"
                          label="Qtd Estratégico"
                          value={formItemArp.qtdEstrategico}
                          id="qtdEstrategico"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          required
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="qtdJudicial"
                          label="Qtd Judicial"
                          value={formItemArp.qtdJudicial}
                          id="qtdJudicial"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          required
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="qtdOutro"
                          label="Qtd Outro"
                          value={formItemArp.qtdOutro}
                          id="qtdOutro"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          required
                        />
                      </CustomCol>
                      <CustomCol>
                        <Input
                          name="qtdTotal"
                          label="Qtd Registrada Total"
                          value={formItemArp.qtdTotal}
                          id="qtdTotal"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol width="150px">
                        <Input
                          name="embalagemTotal"
                          label="Total Embalagens"
                          value={formItemArp.embalagemTotal}
                          id="embalagemTotal"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                    </CustomRow>

                    {/* Valores */}
                    <CustomRow>
                      <CustomCol width="250px">
                        <Input
                          name="valorUnitHomologado"
                          label="Valor Unitário Homologado"
                          value={formItemArp.valorUnitHomologado}
                          id="valorUnitHomologado"
                          onChange={handleChangeItemArp}
                          style={{ textAlign: 'right' }}
                          required
                        />
                      </CustomCol>
                      <CustomCol width="250px">
                        <div
                          style={{
                            marginBottom: '5px',
                            paddingTop: '0px',
                            color: theme.colors.botaoConfirmar,
                          }}
                        >
                          Valor Unitário Reequilíbrio
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '2px',
                          }}
                        >
                          <Checkbox
                            name="valorReequilibrioBin"
                            label=""
                            checked={formItemArp.valorReequilibrioBin}
                            style={{ fontSize: '1.5rem' }}
                            onChange={handleChangeItemArp}
                          ></Checkbox>
                          <Input
                            name="valorUnitReequilibrio"
                            label=""
                            value={
                              formItemArp.valorReequilibrioBin
                                ? formItemArp.valorUnitReequilibrio
                                  ? formatValorDinheiro(
                                      formItemArp.valorUnitReequilibrio,
                                    )
                                  : ''
                                : ''
                            }
                            id="valorUnitReequilibrio"
                            onChange={handleChangeItemArp}
                            readonly={isValorUnitarioHomologadoReadOnly}
                            style={{ textAlign: 'right' }}
                          />
                        </div>
                      </CustomCol>
                      <CustomCol width="250px">
                        <Input
                          name="valorTotal"
                          label="Valor Total R$"
                          value={formItemArp.valorTotal}
                          id="valorTotal"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol></CustomCol>
                    </CustomRow>

                    {/* Quantidades Contratadas */}
                    {/* <CustomRow>
                      <CustomCol
                        width="150px"
                        helpText="Nº de contratos vinculados a esta ARP"
                      >
                        <Input
                          name="medContratos"
                          label="Contratos"
                          value={formItemArp.medContratos}
                          id="medContratos"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="medQtdContratada"
                          label="Qtd Contratada"
                          value={formItemArp.medQtdContratada}
                          id="medQtdContratada"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="medValorContratado"
                          label="Valor Contratado R$"
                          value={formItemArp.medValorContratado}
                          id="medValorContratado"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol width="50px"></CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="medQtdSaldo"
                          label="Qtd de Saldo"
                          value={formItemArp.medQtdSaldo}
                          id="medQtdSaldo"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol width="200px">
                        <Input
                          name="medValorSaldo"
                          label="Valor R$ de Saldo"
                          value={formItemArp.medValorSaldo}
                          id="medValorSaldo"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol width="125px">
                        <Input
                          name="medPercentSaldo"
                          label="% Saldo"
                          value={formItemArp.medPercentSaldo}
                          id="medPercentSaldo"
                          onChange={handleChangeItemArp}
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol></CustomCol>
                    </CustomRow> */}

                    {/* Observações */}
                    <CustomRow>
                      <CustomCol width="100%">
                        <Input
                          id="observacoes"
                          name="observacoes"
                          value={formItemArp.observacoes}
                          label="Observações"
                          type="textarea"
                          onChange={handleChangeItemArp}
                          linhas={3}
                        />
                      </CustomCol>
                    </CustomRow>
                  </BoxConteudo>
                  <BarraInferiorBotoes>
                    {formItemArp.id ? (
                      <WorkspaceBotoes
                        delete
                        onClickDelete={handleDeleteItemArp}
                        save
                        onClickSave={handleUpdateItemArp}
                      />
                    ) : (
                      <WorkspaceBotoes
                        inserir
                        onClickInserir={handleCreateItemArp}
                      />
                    )}
                  </BarraInferiorBotoes>
                </WorkspaceFicha>
              </CustomOffcanvas>

              {/* Seção Partes Envolvidas */}
              <ParteEnvolvidaComponente tab="arp" id_tab={fichaID} />

              {/* Seção Fiscal do Contrato */}
              <FiscalContratoComponente tab="arp" id_tab={fichaID} />

              {/* Seção Responsáveis da Aquisição */}
              <ResponsavelAquisicaoComponente tab="arp" id_tab={fichaID} />

              {/* Seção Termo Aditivo */}
              <TermoAditivoComponente tab="arp" id_tab={fichaID} />

              {/* Seção Tramitação SEI */}
              {/* <TramitacaoComponente tab="arp" id_tab={fichaID} /> */}
            </>
          )}

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formArp.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
